import React from 'react';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

export interface SubSectionHeaderProps {
    title: string;
    linkDestination?: string;
    printMode?: boolean;
    formCompleted: boolean;
}

export const SubSectionHeader: React.FC<SubSectionHeaderProps> = ({
    title,
    linkDestination,
    printMode = false,
    formCompleted,
}) => {
    const navigate = useNavigate();

    const handlePress = useCallback(() => {
        navigate(linkDestination);
    }, [navigate, linkDestination]);

    return (
        <h3>
            {title}
            {!printMode && !!linkDestination && !formCompleted && (
                <button
                    className='button hollow move-button-left-non-accordion'
                    role='link'
                    aria-label='Edit'
                    onClick={handlePress}
                >
                    <img
                        src='assets/img/edit.svg'
                        role='presentation'
                        alt=''
                    />
                    <span className='browser-subheader-edit-button-text'>Edit</span>
                </button>
            )}
        </h3>
    );
};
